export const apiColletions = {
  //auth
  getToken: "/api/auth/get_token",
  signin: "/api/auth/signin",
  signout: "/api/auth/signout",
  verifyOtp: "/api/auth/verify_otp",
  changePassword: "/api/auth/change_password",
  checkRegisterd: "/api/auth/check_registered",

  // update profile

  generateOtp: "/api/auth/generate_otp",
  updateProfile: "/api/auth/update_profile",

  //admin details
  getEntityDetail: "/api/auth/get_entity_detail",

  // Dispatcher role — the panel fetches its own role at login to build the sidebar.
  dispatcherRole: "/api/dispatcher_role",

  //language
  language: "/api/language",
  strings: "/api/language/strings",

  //vehicle type
  vehicleType: "/api/vehicle_type",

  //vahicle
  vehicle: "/api/vehicle",
  vehicleBrand: "/api/vehicle/vehicle_brand",
  vehicleModel: "/api/vehicle/vehicle_model",
  assignVehicle: "/api/vehicle/assign",

  //country
  allCountryList: "/api/country/all",
  country: "/api/country",

  //city
  city: "/api/city",

  //agency
  agency: "/api/agency",

  //notification
  notifiations: "/api/notifiations",

  // Payment apis
  getPaymentGateway: "/api/payment_gateway/user",
  addCardPaymentIntent: "/api/card/intent/add",
  cardApi: "/api/card",
  addWalletPaymentIntent: "/api/payment/intent/create",
  paymentIntent: "/api/payment/intent",

  // Get wallet transaction history
  transactionHistory: "/api/transaction/credit",

  //users
  users: "/api/user",

  //country-city(both)
  countryCityBoth: "/api/country/city",

  //get accessibility
  accessibility: "/api/accessibility",

  //get form field
  formField: "/api/form_field",

  //history
  booking: "/api/booking",
  changeBookingStatus: "/api/booking/taxi/change_status",
  cancelBooking: "/api/booking/cancel",
  bookingPause: "/api/booking/pause",
  location: "/api/location",

  // Recurring bookings — see docs/recurring-booking-brief.md.
  // Server auto-scopes the list endpoint: customers see their own, dispatcher
  // sees rules in their assigned cities (cityIds[]), admin sees everything.
  bookingRecurrence: "/api/booking/recurrence",

  //export history
  exportHistory: "/api/export_history",

  // Ride bookings apis

  getCustomerDetails: "/api/dispatcher/search_customer",
  businessAddressByPhone: "/api/dispatcher/business_address_by_phone", // #12 — lookup directory by phone
  businessAddressCreate: "/api/dispatcher/business_address", // #12 — dispatcher curates the directory
  // Gap 5 / Gap 8 — Message Center + alert bell.
  dispatcherMessages: "/api/dispatcher/messages",
  dispatcherAlerts: "/api/dispatcher/alerts",
  // Quick Booking "Nearest driver" card — same eligibility rules as auto-dispatch,
  // enriched with road distance + traffic-aware ETA to the pickup.
  nearbyDrivers: "/api/dispatcher/nearby_drivers",
  // Calltaker corrects a caller's name from Quick Booking (names only).
  dispatcherUpdateCustomer: "/api/dispatcher/customer",
  getVehicleTypes: "/api/booking/taxi/get_vehicle_types",
  getNearestDriver: "/api/booking/taxi/find_nearest_driver",
  createBooking: "/api/booking/taxi",
  bookingTemplates: "/api/booking/templates",
  address: "/api/address",
  dispatcherBookingsMap: "/api/booking/dispatcher_map",
  reassignBooking: "/api/booking/taxi/reassign",
  fleetBroadcast: "/api/booking/taxi/fleet-broadcast",

  //map views
  driverMapView: "/api/map_view/driver",
  driverDetails: "/api/map_view/driver_detail",

  //cancellation reason
  cancellationReason: "/api/cancellation_reason",

  // cancellation charge

  cancellationCharge: "/api/booking/cancellation_charge",

  //vehicle type cancelltion policy
  vehicleTypeCancellationPolicy: "/api/booking/cancellation_policy",

  // Quick Commerse apis
  reAssignDriver: "/api/booking/taxi/reassign",
  customPrice: "/api/custom_price",

  acceptBooking: "/api/booking/taxi/accept",
  rejectBooking: "/api/booking/taxi/reject",
  getBookingDrivers: "/api/booking/drivers",
  getBookingPickers: "/api/booking/pickers",

  // check business type
  checkBusinessType: "/api/booking/businessType",

  // check business category
  checkBusinessCategory: "/api/booking/businessCategory",

  //Promo Code
  promoCodeList: "/api/booking/promocode_list",
  validatePromoCode: "/api/booking/validate_promo",

  //questions
  question: "/api/question",
};

export const quickCommerceApiColletions = {
  // booking

  acceptBooking: "/api/booking/quick_commerce/merchant/accept",
  acceptMerchantBooking: "/api/booking/quick_commerce/merchant/accept",
  changeBookingStatus: "/api/booking/taxi/change_status",

  // picker
  findPicker: "/api/booking/quick_commerce/find_picker",
  reAssignPicker: "/api/booking/quick_commerce/picker/reassign",
  // for Service
  changeDeliveryStatus: "/api/booking/quick_commerce/merchant/change_status",

  serviceProviders: "/api/booking/service/providers",
  serviceMerchants: "/api/booking/service/merchants",
  assignMerchants: "/api/booking/service/assign",

  acceptPicker: "/api/booking/quick_commerce/picker/accept",
  rejectPicker: "/api/booking/quick_commerce/picker/reject",
  //product
  product: "/api/product",

  //attribute group
  attributeGroup: "/api/attribute/group",

  //attribute
  attribute: "/api/attribute",

  //group
  group: "/api/group",
  //brand
  brand: "/api/brand",

  //tag
  tag: "/api/tag",

  //category
  category: "/api/category",

  //main category
  mainCategory: "/api/main_category",
  //filter type
  filterType: "/api/filter_type",
  //check Business
  checkBusiness: "/api/booking/quick_commerce/check_business",

  //cart
  cart: "/api/cart",

  //booking
  booking: "/api/booking/quick_commerce"
};

export const historyServerApiColletions = {
  //history
  bookingHistory: "/api/booking_history",
  exception: "/api/exception",
  // Admin log GETs live on the history server. Listing them here sends the dispatcher token to HISTORY_URL.
  changeLogs: "/api/change_log",
  apiLogs: "/api/api_log",
  airportApiLogs: "/api/api_log/airport_api_log",

  //map views
  heatmap: "/api/booking_history/map/heatmap",

  //earnings
  earnings: "/api/earning/admin",
  earningDetails: "/api/earning/"
};
export const socketServerApiColletions = {
  location: "/api/location"
};

export const eDeliveryApiColletions = {
  //main category
  mainCategory: "/api/main_category",

  //merchant-list
  merchantList: "/api/booking/delivery/merchants",

  //add-favourite-merchant
  favouriteMerchant: "/api/booking/favourite_merchant",

  //group
  group: "/api/group",

  //tag
  tag: "/api/tag",

  //cart
  cart: "/api/booking/delivery/cart",

  //create order
  booking: "/api/booking/delivery",

  //check Business
  checkBusiness: "/api/booking/delivery/check_business",

  //product details
  productDetails: "/api/product",

  //product filter list
  productFilterList: "/api/product/filterList"
};

export const servicesApiCollections = {
  //check Business
  checkBusiness: "/api/booking/service/check_business",

  //main category
  mainCategory: "/api/main_category",

  //group
  group: "/api/group",

  //cart
  cart: "/api/booking/service/cart",

  //create order
  booking: "/api/booking/service",

  //service providers
  serviceProviders: "/api/booking/service/providers",

  //merchant-list
  merchantList: "/api/booking/service/merchants",

  //product details
  productDetails: "/api/product"
};
